import React, { useEffect } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import Success from '../views/success/Success';
import SuccessExplanation from '../views/success/SuccessExplanation';
import Consent from '../views/consent/Consent';
import Challenge from '../views/challenge/Challenge';
import Decline from '../views/decline/Decline';
import LoaderView from '../views/LoaderView';
import Tokenex3DS from '../views/tokenex/Tokenex3DS';

import { useCommon, fetchConfiguration } from '../store/CommonContext';
import { getSearchParameter } from '../helpers/location-helper';
import * as Sentry from '@sentry/react';
import Links from '../views/links/Links';
import Error from '../views/errors/Error';
import CheckoutError from '../views/errors/CheckoutError';
import { setSentryTags } from '../helpers/sentryHelper';

export const release = 'v1.13.0';

function MainRoutes() {
  const { dispatch } = useCommon();

  console.log(`WidgetShell ${release}`);

  const orderSessionKey = getSearchParameter('orderSessionKey');
  const mid = getSearchParameter('mid');
  const siteId = getSearchParameter('siteId');
  const senseKey = getSearchParameter('senseKey');
  const isCheckout = getSearchParameter('isCheckout');

  useEffect(() => {
    // fetchOrderSessionKey(dispatch);
  }, []);

  useEffect(() => {
    fetchConfiguration(dispatch);
  }, []);

  useEffect(() => {
    try {
      setSentryTags({ widget: 'WidgetShell', release, mid, orderSessionKey, senseKey, siteId, isCheckout });
    } catch (e) {}
  }, []);

  return (
    <Router>
      <Routes>
        {/*<Route path="/" element={<LoaderView />} />*/}
        <Route path="/" element={<Challenge />} />
        <Route path="/1" element={<SuccessExplanation />} />
        <Route path="/2" element={<Consent />} />
        <Route path="/success" element={<Success />} />
        <Route path="/challenge" element={<Challenge />} />
        <Route path="/decline" element={<Decline />} />
        <Route path="/loader" element={<LoaderView />} />
        <Route path="/tokenex-3ds" element={<Tokenex3DS />} />
        <Route path="/links" element={<Links />} />
        {/*<Route path="/error" element={<Error />} />*/}
        <Route path="/error" element={<CheckoutError />} />
        <Route path="/checkout-error" element={<CheckoutError />} />
        {/*<Route path="*" element={<NotFound/>}/>*/}
      </Routes>
    </Router>
  );
}

export default MainRoutes;
